<template>
  <v-layout class="full-height-container" justify-center align-center>
    <v-layout class="form-container">
      <v-form class="form" @submit.prevent="verifyIdentity">
        <h2>
          Welcome, <span class="ph-no-capture">{{ currentIdentity.name }}</span
          >.
        </h2>

        <div v-if="sendingVerificationCode" class="text-xs-left py-2 body-1">
          <div class="pb-2">
            Sending a verification code to your phone at
            {{ maskedPhoneNumber }}. Please wait...
          </div>
        </div>

        <div v-else class="text-xs-left py-2 body-1">
          <div class="pb-2">
            We have sent you a verification code to your phone at
            {{ maskedPhoneNumber }}.
          </div>
          <div class="pb-2">
            Please enter the code below to verify your identity.
          </div>
        </div>

        <v-text-field
          solo
          class="default-input"
          label="Verification code"
          placeholder="Enter verification code"
          v-model="verificationCode"
          :disabled="sendingVerificationCode"
          hide-details
          required
        />

        <v-btn
          block
          large
          color="primary"
          class="mt-3 text-none"
          :disabled="sendingVerificationCode"
          :loading="verifyingCode"
          @click="verifyIdentity"
        >
          <b>Verify</b>
        </v-btn>

        <v-btn
          flat
          block
          color="secondary"
          class="text-none mt-2"
          :loading="sendingVerificationCode"
          :disabled="verifyingCode"
          @click="requestVerificationCode"
        >
          Resend code
        </v-btn>

        <v-btn
          flat
          block
          color="secondary"
          class="text-none mt-2"
          @click="$emit('back')"
        >
          <v-icon small class="mr-2">arrow_back</v-icon>
          Go back
        </v-btn>
      </v-form>
    </v-layout>
  </v-layout>
</template>

<script>
import API from '@/api';

export default {
  props: {
    taxReturnId: {
      type: Number,
      default: null,
    },

    companyId: {
      type: Number,
      default: null,
    },

    currentIdentity: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      sendingVerificationCode: false,
      verifyingCode: false,
      verificationCodeSent: false,
      verificationCode: '',
    };
  },

  computed: {
    maskedPhoneNumber() {
      return 'xxx-xxx-' + this.currentIdentity.phone_number.slice(-4);
    },
  },

  methods: {
    async requestVerificationCode() {
      this.verificationCodeSent = false;
      this.sendingVerificationCode = true;

      try {
        await API.taxReturnIdentityVerification.sendVerificationCode({
          id: this.currentIdentity.id,
          taxReturnId: this.taxReturnId,
          companyId: this.companyId,
        });

        this.verificationCodeSent = true;
      } finally {
        this.sendingVerificationCode = false;
      }
    },

    async verifyIdentity() {
      this.verifyingCode = true;
      try {
        const response = await API.taxReturnIdentityVerification.verifyCode({
          id: this.currentIdentity.id,
          taxReturnId: this.taxReturnId,
          companyId: this.companyId,
          verificationCode: this.verificationCode,
        });

        if (response.data.is_valid) {
          this.$emit('identity-verified', response.data.session_id);
        } else {
          this.$store.dispatch('application/setErrorNotification', {
            message:
              'The verification code you entered is invalid. Please try again.',
          });
        }
      } finally {
        this.verifyingCode = false;
      }
    },
  },

  async mounted() {
    await this.requestVerificationCode();
  },
};
</script>

<style lang="postcss" scoped>
.full-height-container {
  height: 100vh;
}

.form-container {
  max-width: 400px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0 0 0 / 25%);
  background-color: white;
}

.form {
  padding: 12px 16px;

  & >>> h2 {
    padding: 10px 0px;
  }

  & >>> .v-input__slot {
    height: 44px;
  }
}
</style>
